import TransformationCapabilitiesDto from "./TransformationCapabilitiesDto";

class TransformationNotConfigurableDto extends TransformationCapabilitiesDto {

}

export default TransformationNotConfigurableDto;
